<template>
  <div class="quest">
    <div v-if="surveyTemplateModel" class="progress">
      <van-progress :percentage="percentage || 0" :show-pivot="false" stroke-width="6" track-color="#fff" />
      <div>{{ completedCount }}/{{ surveyTemplateModel.questionList?.length }}</div>
    </div>
    <div v-if="surveyTemplateModel" class="scoll" :class="{ 'aoto-height': readonly }">
      <div class="title">{{ surveyTemplateModel.title }}</div>
      <div class="desc">
        {{ surveyTemplateModel.desc }}
      </div>
      <div :style="{ 'padding-bottom': '2.66667vw' }">
        <fda-user-card
          :avatar="surveyInfo?.gender === 2 ? avatarFemale : avatarMale"
          :name="surveyInfo?.fullName"
          :age="surveyInfo?.age"
          :gender="configStore.dict?.gender[surveyInfo?.gender ?? 0]"
          :relation="configStore.dict?.userRelation[surveyInfo?.relation ?? 0]"
        />
      </div>
      <div v-if="surveyTemplateModel" class="quest-list">
        <div v-for="(item, index) in surveyTemplateModel.questionList" :key="index" class="quest-item">
          <div class="quest-item-type">{{ getTypeText(item.type) }}</div>
          <div v-if="item.isRequired" class="icon-star">*</div>
          <div class="quest-item-title">
            <span>{{ index < 9 ? `0${index + 1}` : index + 1 }}</span>
            {{ item.questionTitle }}
          </div>
          <template v-if="isEdit">
            <!-- 单选 -->
            <van-radio-group v-if="item.type === 'radio'" v-model="item.val" :disabled="readonly">
              <div v-for="(option, i) in item.options" :key="i" class="quest-item-option">
                <van-radio :name="i" icon-size="3.73333vw">{{ option }}</van-radio>
              </div>
            </van-radio-group>
            <!-- 多选 -->
            <van-checkbox-group v-if="item.type === 'checkbox'" v-model="item.val" :disabled="readonly">
              <div v-for="(option, i) in item.options" :key="i" class="quest-item-option">
                <van-checkbox :name="i" icon-size="3.73333vw" shape="square">{{ option }}</van-checkbox>
              </div>
            </van-checkbox-group>
            <!-- 文本 -->
            <van-field
              v-if="item.type === 'text'"
              v-model="item.val"
              :disabled="readonly"
              rows="1"
              autosize
              type="textarea"
              :placeholder="readonly && isEdit ? '仅预览，不可输入' : '请输入'"
            />
          </template>
          <div v-else class="read-body" :style="{ color: item.valTxt === '' ? '#C8D0DC' : '#000' }">
            {{ item.valTxt === '' ? '未填写' : item.valTxt }}
          </div>
        </div>
      </div>
    </div>

    <div v-if="!readonly" class="footer">
      <van-button type="primary" block :disabled="isSubmitDisabled" @click="submit">
        {{ isEdit ? '提交' : '修改问卷' }}
      </van-button>
    </div>
  </div>
</template>
<script setup lang="ts">
import avatarFemale from '@/assets/images/avatar-female.png';
import avatarMale from '@/assets/images/avatar-male.png';
import { useFollowUpStore } from '@/store/modules/followUp';
import { useConfigStore } from '@/store/modules/config';
import { FollowUpStatusEnum } from '@/enums/CommonEnum';
import { router } from '@/router';
const followUpStore = useFollowUpStore();
const configStore = useConfigStore();

const isEdit = ref(false);
const surveyTemplateModel = ref();
const surveyInfo = ref();
const getTypeText = (type) => {
  if (type === 'radio') return '单选题';
  if (type === 'checkbox') return '多选题';
  return '填空题';
};

const completedCount = computed(() => {
  console.log('surveyTemplateModel.value', surveyTemplateModel.value);
  return surveyTemplateModel.value?.questionList.reduce((sum, ele) => {
    if (ele.val?.length || typeof ele.val === 'number') return sum + 1;
    return sum;
  }, 0);
});

const percentage = computed(() => {
  if (completedCount.value && surveyTemplateModel.value?.questionList?.length) {
    return Math.ceil((completedCount.value / surveyTemplateModel.value.questionList?.length) * 100);
  }
  return 0;
});
const isSubmitDisabled = computed(() => {
  // 必填且没填，为true，禁用
  return surveyTemplateModel.value?.questionList.some((ele) => ele.isRequired && ele.val?.length === 0);
});

let isUpdate;
const { planId, profileId, questStatus, planStatus } = router.currentRoute.value.query;
const readonly = questStatus === 'read';

isEdit.value = questStatus === 'write' || Number(planStatus) === FollowUpStatusEnum.sending;
console.log('questStatus', questStatus);
const submit = async () => {
  if (!isEdit.value) {
    isEdit.value = true;
    return;
  }
  const answerContent = surveyTemplateModel.value?.questionList.map((s) => {
    let optionIndex: any = [];
    let text = '';
    if (s.type === 'text') {
      text = s.val;
    } else {
      if (s.type === 'radio') {
        optionIndex = (s.val || s.val === 0) ? [s.val] : [];
      } else {
        optionIndex = s.val;
      }
    }
    return {
      questionId: s.questionId,
      optionIndex,
      text,
    };
  });
  const params = {
    isUpdate,
    planId,
    profileId,
    answerContent,
  };
  const res = await followUpStore.completeSurveyAnswer(params);
  if (res) router.replace('/follow-up/complete');
};

const setUp = async () => {
  if (planId) {
    const res = await followUpStore.getFollowUpPlanDetail({ planId, profileId });
    surveyInfo.value = {
      fullName: res.surveyInfo.fullName,
      gender: res.surveyInfo.gender,
      age: res.surveyInfo.age,
      relation: res.surveyInfo.relation,
    };
    isUpdate = !!res.surveyInfo.surveyAnswerModel;
    surveyTemplateModel.value = {
      ...res.surveyInfo.surveyTemplateModel,
      questionList: res.surveyInfo.surveyTemplateModel?.questionList.map((s) => {
        const answer = res.surveyInfo.surveyAnswerModel?.answerContent?.find((a) => a.questionId === s.questionId);
        let val: any = answer?.text ?? '';
        let valTxt = answer?.text ?? '';
        if (s.type !== 'text') {
          if (s.type === 'radio') {
            val = answer?.optionIndex?.[0] ?? '';
            valTxt = s.options[val] ?? '';
          } else {
            val = answer?.optionIndex ?? [];
            valTxt = val
              .map((v) => {
                return s.options[v];
              })
              .join('；');
          }
        }
        return {
          ...s,
          val,
          valTxt,
        };
      }),
    };
  }
};
setUp();
</script>
<style scoped lang="less">
:deep(.van-cell) {
  padding: 8px 20px;
  width: 95%;
  background: #f4f7fa;
  font-size: 28px;
}

:deep(.fda-user-card__bg) {
  border-radius: 8px;
}

:deep(.fda-user-card__mask) {
  left: 24px;
  right: 24px;
}

.progress {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 18px 36px 16px;
  font-size: 22px;

  .van-progress {
    width: 88%;
  }
}

.scoll {
  overflow-y: auto;
  height: calc(100vh - 226px);
}

.quest {
  position: relative;
  margin-bottom: 140px;

  .title {
    margin: 16px 0 32px;
    line-height: 52px;
    text-align: center;
    font-weight: 500;
    font-size: 34px;
    color: #16181a;
  }

  .desc {
    margin: 0 40px;
    line-height: 42px;
    font-weight: 400;
    color: #4e5761;
  }

  .quest-list {
    .quest-item {
      position: relative;
      margin-bottom: 24px;
      padding: 40px 0 0 48px;
      padding-bottom: 20px;
      background-color: #fff;

      .read-body {
        padding: 20px 0;
        border-top: 1px solid #edf0f2;
        border-bottom: 1px solid #edf0f2;
      }

      .icon-star {
        position: absolute;
        left: 20px;
        top: 46px;
        font-weight: 500;
        font-size: 28px;
        color: #ff4b45;
      }

      &-type {
        display: inline-block;
        position: absolute;
        top: 0;
        padding: 4px 12px;
        border-radius: 0 0 4px 4px;
        background: #576b95;
        line-height: 24px;
        font-size: 22px;
        color: #fff;
      }

      &-title {
        padding-bottom: 16px;
        line-height: 42px;
        font-weight: 500;
        color: #16181a;

        span {
          margin-right: 12px;
        }
      }

      &-option {
        padding: 16px 0;
        border-top: 1px solid #edf0f2;
        line-height: 42px;
      }
    }
  }

  .footer {
    position: fixed;
    bottom: 0;
    padding: 16px 32px 64px;
    width: 100%;
    background-color: #fff;

    // prettier-ignore
    box-shadow:
      0 8px 10px -5px rgba(0, 0, 0, 8%),
      0 16px 24px 2px rgba(0, 0, 0, 4%),
      0 6px 30px 5px rgba(0, 0, 0, 20%);
  }

  .aoto-height {
    height: 100%;
  }
}
</style>
